import { render, staticRenderFns } from "./TestPlaidConnection.vue?vue&type=template&id=1dda67a4&"
import script from "./TestPlaidConnection.vue?vue&type=script&lang=ts&"
export * from "./TestPlaidConnection.vue?vue&type=script&lang=ts&"
import style0 from "./TestPlaidConnection.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports